"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeatureFlag = exports.useAreFeatureFlagsLoading = exports.IssuesLaunchDarklyProvider = exports.IssuesLDContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyProvider = require("@adsk/alloy-provider");
var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");
var _useLDUserCustom = require("../hooks/useLDUserCustom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const IssuesLDContext = exports.IssuesLDContext = _react.default.createContext(undefined);

// @ts-ignore because useAllFeatureFlags is mistyped in alloy
const {
  LaunchDarklyProvider,
  useFeatureFlag,
  useAllFeatureFlags
} = (0, _alloyProvider.createLaunchDarklyContext)(IssuesLDContext);
exports.useFeatureFlag = useFeatureFlag;
const clientSideIdByEnv = {
  [_acsScWebPlatformApi.ENVS.QA]: "5f330ba0ce51a209a3d891ba",
  [_acsScWebPlatformApi.ENVS.STAGING]: "5f330ba07a187208df747199",
  [_acsScWebPlatformApi.ENVS.PRODUCTION]: "5f330b9f60ab86092ac1498b"
};

/**
 * Exposes issues-related feature flags to its consumers.
 */
const IssuesLaunchDarklyProvider = _ref => {
  let {
    children
  } = _ref;
  const env = (0, _acsScWebPlatformApi.getEnv)();
  const customUserAttrs = (0, _useLDUserCustom.useUserCustom)();
  return /*#__PURE__*/_react.default.createElement(LaunchDarklyProvider, {
    apiKey: clientSideIdByEnv[env],
    customUserAttrs: customUserAttrs
  }, children);
};
exports.IssuesLaunchDarklyProvider = IssuesLaunchDarklyProvider;
const useAreFeatureFlagsLoading = () => useAllFeatureFlags().loading;
exports.useAreFeatureFlagsLoading = useAreFeatureFlagsLoading;
//# sourceMappingURL=IssuesLaunchDarklyProvider.js.map